import { render, staticRenderFns } from "./MoblieTech.vue?vue&type=template&id=61197af7&scoped=true&"
import script from "./MoblieTech.vue?vue&type=script&lang=js&"
export * from "./MoblieTech.vue?vue&type=script&lang=js&"
import style0 from "./MoblieTech.vue?vue&type=style&index=0&id=61197af7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61197af7",
  null
  
)

export default component.exports